/**
 * Which options to offer for what has been typed, and how many matched overall.
 *
 * Kept apart from the component so the ranking rules can be tested on their own.
 *
 *   - names that BEGIN with the query come before names that merely contain it,
 *     because someone typing "how" wants Howrah before "Beltala Howrah Road";
 *   - matching ignores case, since the imported city master is upper case while
 *     the older entries are title case, and half of it would otherwise be
 *     unreachable;
 *   - the result is capped, so a 600-entry master never renders in full.
 */
export const DEFAULT_MAX_VISIBLE = 60;

export const filterOptions = (options, query, max = DEFAULT_MAX_VISIBLE) => {
  const list = options || [];
  const q = (query || '').trim().toLowerCase();
  if (!q) return { shown: list.slice(0, max), total: list.length };

  const starts = [];
  const contains = [];
  list.forEach((o) => {
    const label = (o.label || '').toLowerCase();
    if (label.startsWith(q)) starts.push(o);
    else if (label.includes(q)) contains.push(o);
  });
  const matches = [...starts, ...contains];
  return { shown: matches.slice(0, max), total: matches.length };
};

export default filterOptions;
